import React from 'react';

export default function CtaStrip({ heading, subtext, buttonLabel, onAction }) {
  return (
    <div className="section-pad" style={{
      background: 'var(--ms-blue)', padding: '72px 48px', textAlign: 'center',
    }}>
      <h2 style={{ fontSize: 'clamp(20px, 2.5vw, 32px)', fontWeight: 700, color: '#fff', marginBottom: '10px' }}>
        {heading}
      </h2>
      <p style={{ fontSize: '15px', color: 'rgba(255,255,255,0.8)', marginBottom: '32px' }}>
        {subtext}
      </p>
      <button
        onClick={onAction}
        style={{
          background: '#fff', color: 'var(--ms-blue)',
          padding: '12px 32px', borderRadius: '4px',
          fontSize: '14px', fontWeight: '600', border: 'none', transition: 'all 0.15s',
        }}
        onMouseEnter={e => e.target.style.background = 'var(--ms-blue-pale)'}
        onMouseLeave={e => e.target.style.background = '#fff'}
      >
        {buttonLabel}
      </button>
    </div>
  );
}
